module.exports = __webpack_public_path__ + "31d8e494ea6535d232466e30be9ee327.svg";